import { AppRoutes } from '@/constants';
import { navigate } from '@/providers';

import { XCloseIcon } from '@/assets/icons';
import { AuthGlassContainer, Button } from '@/components/common';

export const InvalidPasswordReset = () => {
  return (
    <AuthGlassContainer className="w-[400px] flex flex-col items-center justify-center">
      <div className="size-[50px] bg-red-darkest border border-red-base rounded-lg flex flex-row items-center justify-center">
        <XCloseIcon className="size-6 text-neutral-0" />
      </div>
      <span className="text-neutral-0 text-body-base font-semibold text-center mt-6 mb-2">
        This password reset link is invalid or has expired!
      </span>
      <span className="font-medium text-body-sm text-opacity-light-70 text-center">
        Please request a new one.
      </span>
      <Button
        size="lg"
        buttonColor="neutral"
        buttonStyle="textlink"
        className="!text-neutral-5 mt-6"
        onClick={() => navigate(AppRoutes.FORGOT_PASSWORD)}
      >
        Back to Forgot Password
      </Button>
    </AuthGlassContainer>
  );
};
